import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DonatePage from "@/pages/DonatePage";
import SuccessPage from "@/pages/SuccessPage";
import CancelPage from "@/pages/CancelPage";
import EmbedHelpPage from "@/pages/EmbedHelpPage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App min-h-screen">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DonatePage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="/embed" element={<EmbedHelpPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
